import { render } from "./TheClosedAlarmsList.vue?vue&type=template&id=3e86bc12"
import script from "./TheClosedAlarmsList.vue?vue&type=script&lang=js"
export * from "./TheClosedAlarmsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__